'use strict';

var Backbone = require('backbone'),
  $ = require('jquery'),
  config = require('../../js/config'),

  EngineerSupportView = Backbone.View.extend({

    events: {
      'click .Engineers-list-item': 'select'
    },

    initialize: function() {
    },

    select: function(e) {
      this.$el.removeClass(config.classes.isActive);
      $(e.currentTarget).addClass(config.classes.isActive);

    // Supposed to change the engineer module for the selected item in the list
    // but I assume this is going to be more than an image chance
    // $selectedEngineer = $target.find('img').attr('src');
    // this.$('.DesignCenter-engineer-selected img').attr('src', $selectedEngineer);
    }

  });

module.exports = EngineerSupportView;



// WEBPACK FOOTER //
// ./assets/components/Engineer/EngineerSupportView.js